import { render, staticRenderFns } from "./PHQQuestionnairePanels.vue?vue&type=template&id=6ea0902a&"
import script from "./PHQQuestionnairePanels.vue?vue&type=script&lang=js&"
export * from "./PHQQuestionnairePanels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports